import { render } from "./Messenger.vue?vue&type=template&id=242c5762"
import script from "./Messenger.vue?vue&type=script&lang=js"
export * from "./Messenger.vue?vue&type=script&lang=js"
script.render = render

export default script